import { connect } from 'react-redux';
import MultiMeasureFormFillPage from './MultiMeasureFormFill';

const mapStateToProps = (state) => ({
  userPermissions: state.user.permissions
});

const ConnectedComponent = connect(mapStateToProps)(MultiMeasureFormFillPage);

const MultiMeasureFormFillPageWrapper = ({ isExternalForm = false }) => {

  const ComponentToRender = isExternalForm ? MultiMeasureFormFillPage : ConnectedComponent;
  return <ComponentToRender isExternalForm={isExternalForm} />;
};

export default MultiMeasureFormFillPageWrapper;
